import { useState, useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";

import { Button, Container, Box, Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'


import CardItem from './CardItem'


export default function News() {

  const { t, i18n } = useTranslation();

  const [index, setIndex] = useState()

  const [items, setItems] = useState([])

  function read(i) {
    if (i18n.language === "de")
      fetch("news/" + i + "/data_de.json")
        .then((response) => response.json())
        .then((data) => {
          setItems(items => [...items, data]);
        })
        .catch(rejected => {
          console.log(rejected);
        });
    else
      fetch("news/" + i + "/data_it.json")
        .then((response) => response.json())
        .then((data) => {
          setItems(items => [...items, data]);
        })
        .catch(rejected => {
          console.log(rejected);
        });

  }

  const arrayRangeUp = (start, stop) =>
    Array.from(
      { length: (stop - start) + 1 },
      (value, index) => start + index
    );

  const arrayRangeDown = (start, stop) =>
    Array.from(
      { length: (stop - start) + 1 },
      (value, index) => stop - index
    );


  useEffect(() => {

    if (index !== undefined) {
      //Iterate bis Fehler
      setItems([]);

      arrayRangeDown(index.start, index.end).map((i) => {
        read(i);
      })
    }

  }, [index])

  useEffect(() => {

    fetch("news/index.json")
      .then((response) => response.json())
      .then((data) => {setIndex(data);})
      .catch(rejected => { console.log(rejected);});

  }, [i18n])

  return (

    <Container id="news" className="border-t-2 border-slate-950 border-dotted bgwhite vp">

      <Title text="Item4" variant="big" color="orange"></Title>

      <Grid container flexDirection="column" alignContent="center" className="px-0" spacing={2}>

        {items.map((it, index) => {
          return (
            <>
              <CardItem key={index} item={it} />
            </>
          )
        }
        )}

      </Grid>

    </Container>
  );
}
